import { useState } from "react";
import { Link } from "react-router-dom";
import InstallInquiryModal from "@/components/base/InstallInquiryModal";

const BannerSection = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="relative rounded-2xl overflow-hidden" style={{ minHeight: "400px" }}>
          <img
            src="https://public.readdy.ai/ai/img_res/8eed101dfcfdfbfc44b2563a116cabc1.jpg"
            alt="도어준 프로모션"
            className="w-full h-full object-cover object-top absolute inset-0"
            style={{ minHeight: "400px" }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/45 to-transparent" />
          <div className="relative z-10 flex flex-col justify-center h-full p-10 md:p-16" style={{ minHeight: "400px" }}>
            <span className="text-xs font-bold tracking-widest uppercase text-white/60 mb-4">Spring Special</span>
            <h2 className="text-3xl md:text-5xl font-black text-white mb-4 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              지금 설치하면<br />
              <em className="not-italic text-white/60">무료 설치비 지원</em>
            </h2>
            <p className="text-sm text-white/70 mb-3 max-w-xs">
              2026년 봄 한정 프로모션. 도어준 Pro 시리즈 구매 시 전문 기사 설치비 전액 무료.
            </p>

            <div className="flex items-center gap-4 flex-wrap">
              <Link
                to="/categories"
                className="inline-flex items-center gap-2 bg-white text-stone-900 text-sm font-bold px-7 py-3 rounded-full hover:bg-stone-100 transition-colors whitespace-nowrap cursor-pointer"
              >
                제품 보러가기
                <i className="ri-arrow-right-line" />
              </Link>
              <button
                onClick={() => setShowModal(true)}
                className="inline-flex items-center gap-2 border border-white/40 text-white text-sm font-semibold px-7 py-3 rounded-full hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line" />
                설치 문의
              </button>
            </div>
          </div>
        </div>
      </div>
      {showModal && <InstallInquiryModal onClose={() => setShowModal(false)} />}
    </section>
  );
};

export default BannerSection;
